import React, { useState, useEffect, useRef, useCallback } from "react";
import { Rnd } from "react-rnd";
import Config from "../../Config.json";
import classNames from 'classnames';
import {animDropDown, processCSS, handleInputFocus, processHtmlText, hexToRgb, rgbToHex} from "../../utils/form.tools";
import { el } from "date-fns/locale";
import gsap from "gsap";
import { Draggable } from "gsap/all";
import { conforms, isEqual } from 'lodash';
import { apiCall } from "../narrativeUtils/fetch";
import {
  createKeyboardListenerManager,
  handleBackspace,
  handleDelete,
  getStyleAtPosition,
  createDebouncedTextUpdater,
  getCurrentTextState,
  extractTextAndStyles,
  mergeClipboardContent,
  parseClipboardData,
  getSelectionRange,
  setCaretPosition,
  setSelectionRange
} from "../narrativeUtils/textEditing";
import SVG from 'react-inlinesvg';
// import SvgFreehand from "../modules/draw";
import PaperCanvas from "../modules/paper";

// import { ScrollZoomHandler } from "mapbox-gl";
gsap.registerPlugin(Draggable)
function Frame(props) {
  const layerClickCooldownRef = useRef(false);
   const screens = useRef();
    const guidelines = useRef();
    const scrollBar = useRef();
    const handle = useRef();
    const scrollBarHoriz = useRef();
    const handleHoriz = useRef();
    const frameCanvas = useRef();
    const frameElemBox = useRef(null)
    const frameElem = useRef(null);
    const frameZoomElem = useRef(null);
    const selectDrag = useRef(false);
    const isDragging = useRef(false);
    const selectCleared = useRef(false);
    const textEditDiv = useRef();
    const mouseDownListener = useRef();
    const isTypingTimer = useRef();
    const zoomNumberRef = useRef();
    const insetZoomRatioRef = useRef(0);

    // const mouseMoveListener = useRef();
    const mouseUpListener = useRef();
    const selectionListener = useRef();
    const keyboardManager = useRef(createKeyboardListenerManager());
    const editorOn = useRef(null);
    const [isTextEditing, setIsTextEditing] = useState(false);
    const tempTextObj = useRef();
    const debouncedTextUpdater = useRef(null);
    const skipKeyUpUntil = useRef(0); // Skip keyups until this timestamp (after paste/cut)
    const pendingTextState = useRef(null); // Immediate text state for rapid typing (before debounce fires)
    const selectionInProgress = useRef(false); // Guard against onSelect firing multiple times
    const scrollPosY = useRef(0);
    const scrollPosX = useRef(0);


    const [frameDelta, setFrameDelta] = useState(null);
    const [isSelecting, setIsSelecting] = useState(false);
    const [zoomRatio, setZoomRatio] = useState();
    const [initFrame, setInitFrame] = useState(null);
    const [inset, setInset] = useState();
    const [insetZoomRatio, setInsetZoomRatio] = useState(null);
    const [reRender, setReRender] = useState(0);
    const [autoFocusTextId, setAutoFocusTextId] = useState(null);
    const pendingFocusId = useRef(null); // Store ID when dimension not yet in array
    // const [reloadPaper, setReloadPaper] = useState(0);
    // const [frameReady, setFrameReady ] = useState(false);


    
    function handleZoomHeight() {
      let h = frameCanvas.current.offsetHeight + 40;
      frameZoomElem.current.style.height = h + "px";
    }

    function adjustHandle(){
      // console.log('adjustHandle fired')
      let scrollX;
      let scrollY;

    function processDelta(isVert, canvasContainerPos, zoomAreaPos, zoomAreaSize, canvasContainerSize) {
        let scrollPerc = (canvasContainerPos - zoomAreaPos)/canvasContainerSize;
        let scrollPerc2 = (zoomAreaPos + (zoomAreaSize - canvasContainerSize)-canvasContainerPos)/canvasContainerSize;
        // console.log("processDelta", isVert ? "vertical":"horizontal", canvasContainerPos, zoomAreaPos, zoomAreaSize, scrollPerc, scrollPerc2)

        if (scrollPerc > 0.5) {
          scrollPerc = 0.5;
        }
        if (scrollPerc < 0) {
          scrollPerc = 0;
        }
        if (scrollPerc2 > 0.5) {
          scrollPerc2 = 0.5;
        } 
        if (scrollPerc2 < 0) {
          scrollPerc2 = 0;
        }

        return [scrollPerc, scrollPerc2];
      }

      let scrollXPerc;
      let scrollYPerc = [0,0];
      
      if (frameElemBox.current) {
        scrollXPerc = processDelta(false, parseInt(frameElemBox.current.getBoundingClientRect().x), parseInt(frameZoomElem.current.getBoundingClientRect().x), parseInt(frameZoomElem.current.getBoundingClientRect().width), parseInt(frameElemBox.current.getBoundingClientRect().width));

        let scrollYPerc = processDelta(true, parseInt(frameElemBox.current.getBoundingClientRect().y), parseInt(frameZoomElem.current.getBoundingClientRect().y), parseInt(frameZoomElem.current.getBoundingClientRect().height), parseInt(frameElemBox.current.getBoundingClientRect().height))
      
        scrollY = parseInt(scrollBar.current.offsetHeight * scrollYPerc[0]);
      }
      
      if (scrollBarHoriz.current){
        scrollX = parseInt(scrollBarHoriz.current.getBoundingClientRect().width * scrollXPerc[0]);
      }

      scrollPosX.current = scrollX;
      scrollPosY.current = scrollY;

      // console.log('scrollX', scrollX, scrollXPerc)
      // console.log('scrollY', scrollY, scrollYPerc)
      let scrollYHandle = -1;
      let scrollXHandle = -1;

      if (scrollXHandle < 50) {
        scrollXHandle = 50;
      }

   


      if (scrollBar.current) {
          scrollYHandle = parseInt(scrollBar.current.offsetHeight) * (100-parseInt(scrollYPerc[0]*100)-parseInt(scrollYPerc[1]*100))/100;

          if (scrollYHandle >= scrollBar.current.offsetHeight) {
            gsap.to(handle.current, {y: scrollY, height: scrollYHandle, duration: 0, opacity: 0});
          } else {
            gsap.to(handle.current, {y: scrollY, height: scrollYHandle, duration: 0.2, opacity: 1});
          }

          
      }
      if (scrollBarHoriz.current) {
        scrollXHandle = parseInt(scrollBarHoriz.current.offsetWidth) * (100-(parseInt(scrollXPerc[0]*100)+parseInt(scrollXPerc[1] * 100)))/100;

        if (scrollXHandle >= scrollBarHoriz.current.offsetWidth) {
          gsap.to(handleHoriz.current, {x: scrollX, width: scrollXHandle, duration: 0.2, opacity: 0});
        } else {
          gsap.to(handleHoriz.current, {x: scrollX, width: scrollXHandle, duration: 0.2, opacity: 1});
        }

        
      }
      // props.setZoomDelta([parseFloat(scrollX/parseInt(frameElemBox.current.getBoundingClientRect().width)), parseFloat(scrollY/parseInt(frameElemBox.current.getBoundingClientRect().height))])

      // console.log('scrollHandles', parseFloat(scrollX/parseInt(frameElemBox.current.getBoundingClientRect().width)).toFixed(4), parseFloat(scrollY/parseInt(frameElemBox.current.getBoundingClientRect().height)).toFixed(4))
      
      // console.log('scrollX, scrollY', scrollX, scrollY)
      
      runFrameDelta();
    
     
    }

    function onFrameLoad(){
      props.setShowLoader(false);
      setInitFrame([frameZoomElem.current.offsetWidth,frameZoomElem.current.offsetHeight])
    }


    function runFrameDelta(){
      console.log('runFrameDelta', zoomNumberRef.current)
      if (frameElem.current && frameZoomElem.current) {

        // if (frameDelta){
        //     runFrameDelta()
        //     setTimeout(() => {
        //       props.onZoomChoice('fit')
        //     }, 300);
        //   }

        let deltaX = (frameElem.current.getBoundingClientRect().x - frameZoomElem.current.getBoundingClientRect().x)/zoomNumberRef.current;
        let deltaY = (frameElem.current.getBoundingClientRect().y - frameZoomElem.current.getBoundingClientRect().y)/zoomNumberRef.current;

        let deltaX2 =( 0 - frameZoomElem.current.getBoundingClientRect().width)/zoomNumberRef.current;
        let deltaY2 = (0 - frameZoomElem.current.getBoundingClientRect().height)/zoomNumberRef.current;

       

        setFrameDelta([deltaX, deltaY, deltaX2, deltaY2])

        // console.log('deltaX, deltaY, deltaX2, deltaY2', deltaX, deltaY, deltaX2, deltaY2)
      }
      
    }

    useEffect(() => {
    

      Draggable.create(handle.current, {
        type:"y",
        bounds: scrollBar.current,
        edgeResistance: 1,
        onDragStart: function(e) {
          // console.log("drag start", e.y, e);
        },
        onDrag: function(e) {
          let yPosPx = scrollPosY.current - (handle.current.getBoundingClientRect().top - 52);
          let yPerc = yPosPx / scrollBar.current.offsetHeight;
          let offset = frameElemBox.current.getBoundingClientRect().height * yPerc;

          // let offset = frameElemBox.current.getBoundingClientRect().height * yPerc;
          let adjustedOffset = 0;
          if (offset > 0) {
            adjustedOffset = offset + 50
          } else {
            adjustedOffset = offset - 0
          }
          
          // console.log('onDrag', offset, yPerc, yPosPx)
          gsap.to('.canvasPage', {y: adjustedOffset, duration: 0.2})
          // scrollPosY.current = offset
        },
        onDragEnd: function(e) {
          // console.log("drag end", (e.y-51)/scrollBar.current.offsetHeight, e);
        }
      });

      Draggable.create(handleHoriz.current, {
        type:"x",
        bounds: scrollBarHoriz.current,
        edgeResistance: 1,
        onDragStart: function(e) {
          // console.log("drag start", e.y-78);
        },
        onDrag: function(e) {
          
          let xPosPx = scrollPosX.current - (handleHoriz.current.getBoundingClientRect().left - 301);

          let xPerc = xPosPx / scrollBarHoriz.current.offsetWidth;
          let offset = frameElemBox.current.getBoundingClientRect().width * xPerc;
          let adjustedOffset = 0;
          if (offset > 0) {
            adjustedOffset = offset + 50
          } else {
            adjustedOffset = offset - 0
          }
          
          // console.log('onDrag H', xPosPx, handleHoriz.current.getBoundingClientRect().left - frameElem.current.getBoundingClientRect().x)
          gsap.to('.canvasZoom', {x: adjustedOffset, duration: 0.2})

          // scrollPosY.current = offset
        },
        onDragEnd: function(e) {
     
          // console.log("drag end", (e.y-51)/scrollBar.current.offsetHeight, e);
        }
      });

      let canvasDrag = Draggable.create(frameCanvas.current, {
        type:"x,y",
        // bounds: frameElemBox.current, 
      });
      canvasDrag[0].disable();

      function startCanvasDrag(e) {
        if (e.keyCode === 32) {
          canvasDrag[0].enable();
        }
      }

      function stopCanvasDrag(e) {
        if (e.keyCode === 32) {
          canvasDrag[0].disable();
          adjustHandle();
        }
      }

      zoomNumberRef.current = props.zoomNumber

      // Function to be called once the #loading element is gone
      // function onLoadingRemoved() {
      //   console.log('#loading has been removed from the DOM!');
      //   runFrameDelta();
      //   setTimeout(() => {
          
      //     setFrameReady(true)
      //   }, 300);
      // }

      // const observer = new MutationObserver((mutations, obs) => {
      //   if (!document.getElementById('loading')) {
      //     onLoadingRemoved();
      //     obs.disconnect();
      //   }
      // });
      // observer.observe(document.body, { childList: true, subtree: true });


      window.addEventListener('keydown', startCanvasDrag)
      window.addEventListener('keyup', stopCanvasDrag)
   
      
      return () => {
        // setZoomRatio(null);
        zoomNumberRef.current = 1;
        // Cleanup keyboard listener on unmount
        keyboardManager.current.detach();
      }

    }, [])

    useEffect(() => {
      if (props.reloadFrame > 0) {
        //  setTimeout(() => {
        //   let curr = reRender;
        //   setReRender(curr+=1);
        // }, 300);
      }
    }, [props.reloadFrame])



    useEffect(() => {
      if (props.loading && props.zoomRatio) {
        let curr = reRender;
        console.log('curr',curr+=1)
        setTimeout(() => {
          setReRender(curr+=1);
        }, 300);
       
      }
    }, [props.loading, props.zoomRatio])

  
useEffect(() => {
 console.log('key test', props.test)
}, [props.test])


    useEffect(() => {
      if (props.zoomNumber && frameZoomElem.current && frameElem.current && props.componentDimensions && props.activeSectionObj) {

        
        if (zoomNumberRef.current !== props.zoomNumber) {
          zoomNumberRef.current = props.zoomNumber
          // console.log("props.zoomNumber", props.zoomNumber, zoomNumberRef.current)
          gsap.to(frameZoomElem.current, {scale: props.zoomNumber, duration: 0.3, onComplete: () => {
              adjustHandle()
          }})
        } else {
          // console.log("props.zoomNumber unchanged", props.zoomNumber, zoomNumberRef.current)
          setTimeout(() => {
            gsap.to(frameZoomElem.current, {scale: props.zoomNumber, duration: 0, onComplete: () => {
              adjustHandle()
        
            }})
          }, 300);
      
         
        }
    
        // console.log('Frame zoomNumber', props.zoomNumber, zoomNumberRef.current, zoomRatio)
      
    }
  }, [props.zoomNumber, props.componentDimensions, props.activeSectionObj])

    useEffect(() => {
      // Flush any pending debounced text updates before clearing
      if (debouncedTextUpdater.current) {
        debouncedTextUpdater.current.flush();
      }
      // Clear selection and temp text when active item changes (including when deselected)
      props.setSelection(null)
      props.setTempText(null)
      // Also clear the immediate text refs
      pendingTextState.current = null;
      if (props.tempTextObj) {
        props.tempTextObj.current = null;
      }
    }, [props.activeSettingId])

    // Clear browser's native selection when our selection state is cleared
    useEffect(() => {
      if (!props.selection) {
        window.getSelection()?.removeAllRanges();
      }
    }, [props.selection])

    // Cleanup on unmount
    useEffect(() => {
      return () => {
        // Cancel any pending debounced updates
        if (debouncedTextUpdater.current) {
          debouncedTextUpdater.current.cancel();
        }
        // Detach keyboard listener
        keyboardManager.current.detach();
      };
    }, [])

    useEffect(() => {

      if (props.activeSectionObj && props.activeDisplay && frameElem.current) {
        props.setShowLoader(false)
        console.log('frameElem Rendered')
        let heightDiff = frameElem.current.offsetHeight/props.activeDisplay.height_px;
        setZoomRatio(heightDiff);
        console.log('setting Zoom Ratio', heightDiff, frameElem.current.offsetHeight)
        
    
      } 
    }, [props.activeSectionObj, props.activeDisplay])



    useEffect(() => {

      if (props.activeDisplay && props.narrative.insets) {


       

        let insetObj = props.narrative.insets.filter(a => a.display === props.activeDisplay.id);
        // console.log('insetObj', insetObj, props.narrative.insets)
        if (insetObj) {
          setInset(insetObj[0]);
          let elemHeight;
          setTimeout(() => {
            let elemHeightObj = document.getElementById('bounds');
            if (elemHeightObj) {
              elemHeight = elemHeightObj.offsetWidth - 2;
              let ratio = elemHeight / props.activeDisplay.width_px
              // console.log('setInsetZoomRatio', ratio, elemHeight, props.activeDisplay.width_px)
              setInsetZoomRatio(ratio)
              setTimeout(() => {
                console.log('running runFrameDelta')
                runFrameDelta();
              }, 300);
              
            }
            // console.log('inset', insetObj[0])
          }, 150);
          // This timing is too brittle.

     
        }
      }
    }, [props.activeDisplay, props.narrative])

    // useEffect(() => {
    //   console.log("ZOOM RATIO", zoomRatio)
    // }, [zoomRatio])


    function mouseMoveListener() {
      if (!selectDrag.current) {
        selectDrag.current = true
        
      }
      console.log('mousemove')
    }
    
    mouseDownListener.current = () => {
      selectDrag.current = false
    }

    async function clearSelected() {
      console.log('clearSelected')
      // Note: This does NOT clear the native browser selection - that's intentional
      // because this function is called during onSelectStart before reading the selection.
      // Native selection is cleared explicitly in escClear() when exiting edit mode.
      return true
    }


    mouseUpListener.current = () => {
      console.log('mouseUpListener on')
      clearSelected();
    }

    function getCaretCharacterOffsetWithin(element) {
      var caretOffset = 0;
      var doc = element.ownerDocument || element.document;
      var win = doc.defaultView || doc.parentWindow;
      var sel;
      if (typeof win.getSelection != "undefined") {
          sel = win.getSelection();
          if (sel.rangeCount > 0) {
              var range = win.getSelection().getRangeAt(0);
              var preCaretRange = range.cloneRange();
              preCaretRange.selectNodeContents(element);
              preCaretRange.setEnd(range.endContainer, range.endOffset);
              caretOffset = preCaretRange.toString().length;
          }
      } else if ( (sel = doc.selection) && sel.type !== "Control") {
          var textRange = sel.createRange();
          var preCaretTextRange = doc.body.createTextRange();
          preCaretTextRange.moveToElementText(element);
          preCaretTextRange.setEndPoint("EndToEnd", textRange);
          caretOffset = preCaretTextRange.text.length;
      }
      return caretOffset;
  }




    function getCharacterRangeOfSelection(charOverrides) {
      let id;
      const selection = window.getSelection();      
      const range = selection.getRangeAt(0);  
      const length = range.toString().length;

      console.log('range length', length, range.toString())
 
      let changeArray = []
      if (charOverrides && charOverrides.length > 0) {
        changeArray = [...charOverrides]
      }
      const offsetStartPosition = getCaretCharacterOffsetWithin(selection.baseNode.parentElement.parentElement) - length;
      const offsetEndPosition = getCaretCharacterOffsetWithin(selection.baseNode.parentElement.parentElement);
      // console.log('characterRange selection', selection, offsetStartPosition, offsetEndPosition)

      for (let i = 0; i < offsetEndPosition; i++) {
     
        if (i < offsetStartPosition) {
          // Look for existing character. If it exists, skip it; if no char exists assign 0.
          // console.log('i < startPosition', changeArray[i], i, startPosition)
          if (!changeArray[i]) {
            changeArray[i] = 0
          }
          
        } else {

          if (changeArray[i] && !id) {
            id = [changeArray[i]];
          } else if (changeArray[i] && id) {
            id.push(changeArray[i])
          }  

          if (!changeArray[i] && id) {
            id.push(0)
          }
          if (!changeArray[i] && !id) {
            id = [0];
          }
          
          // Assign Temp 1 to be then given ID of style override 
          // console.log('i >= startPosition', changeArray[i], i, endPosition)
          changeArray[i] = 1
         
        }
     
      }
      let result = {'range': changeArray, 'id': id, 'selectionRange': [offsetStartPosition, offsetEndPosition]};
      
      console.log("getCharacterRangeOfSelection", result)
      
      return result
    }


    function onSelectStart(html_text, id, tempText) {

      console.log('onSelectStart called', 'selType:', window.getSelection().type, 'selectDrag:', selectDrag.current, 'selectionInProgress:', selectionInProgress.current, 'props.selection:', props.selection);

      // Guard against onSelect firing multiple times (e.g., after re-render)
      if (selectionInProgress.current) {
        console.log('onSelectStart: skipping - selection already in progress');
        return;
      }

      // If we already have a selection set, don't process again (prevents clearing on re-render)
      if (props.selection && props.selection.dimensionId === id) {
        console.log('onSelectStart: skipping - selection already exists for this dimension');
        return;
      }

      if (window.getSelection().type === "Range" && !selectDrag.current) {
        // Set guard immediately (synchronous)
        selectionInProgress.current = true;

        // Use pendingTextState for most up-to-date state during editing
        const currentState = pendingTextState.current || tempText;
        if (currentState) {
          html_text = currentState;
        }
        console.log('onSelectStart using html_text:', html_text);
        
        clearSelected().then(function() {
          // setIsSelecting(true);
          let selection =  window.getSelection();

          console.log('onSelectStart inside then:', 'selection text:', selection?.toString(), 'length:', selection?.toString().length);

          if (selection && /\S/.test(selection.toString())) {
            let charOverrides;
          
            if (html_text['charStyleOverrides'] && html_text['charStyleOverrides'].length > 0) {
              charOverrides = html_text['charStyleOverrides']
            }
            // console.log('charOverrides start', charOverrides, props.selection)
            const range = getCharacterRangeOfSelection(charOverrides);
            selectDrag.current = false;
            // console.log('setSelected', range.range, range.id)
            props.setSelection({'range': range.range, 'styleIds': range.id, 'selectionRange': range.selectionRange, 'dimensionId': id});
            console.log('setSelection called with:', range.range, range.selectionRange);

            // Reset guard after re-render completes
            setTimeout(() => { selectionInProgress.current = false; }, 500);

            console.log('selection', selection)
            // Selection highlighting is now handled by processHtmlText via props.selection
          } else {
            // Clear selection when no text is selected (clicked elsewhere in text)
            console.log('onSelectStart: clearing selection because no text selected');
            // Only clear native browser selection if we had an active selection before
            if (props.selection) {
              window.getSelection()?.removeAllRanges();
            }
            props.setSelection(null);
            selectionInProgress.current = false;
          }

        })


        
      }
    }

  // Restore browser selection after React re-renders with new selection state
  useEffect(() => {
    if (props.selection && props.selection.selectionRange && props.selection.dimensionId) {
      // Only restore if we're actively editing this text layer
      if (editorOn.current === props.selection.dimensionId) {
        const textElement = document.getElementById("dim_text_" + props.selection.dimensionId);
        if (textElement) {
          // Use requestAnimationFrame to ensure DOM has updated
          requestAnimationFrame(() => {
            const [start, end] = props.selection.selectionRange;
            const success = setSelectionRange(textElement, start, end);
            console.log('Restored browser selection:', start, end, 'success:', success);
          });
        }
      }
    }
  }, [props.selection])



  useEffect(() => {
    // console.log('isSelecting: ', isSelecting)
    if(textEditDiv.current && isSelecting) {
      console.log('isSelecting', isSelecting)
      textEditDiv.current.addEventListener('mousedown', mouseDownListener.current)
      textEditDiv.current.addEventListener('mousemove', mouseMoveListener)
      textEditDiv.current.addEventListener('mouseup',  mouseUpListener.current)

    }
  }, [isSelecting, textEditDiv.current])

  useEffect(() => {
   

    // console.log('props.updateFetch', props.updateFetch,  props.activeSettingId)
    if (props.updateFetch > -1 && props.activeSectionObj) {
      let url = Config.baseURLcms + "section/" + props.activeSectionObj.id;

      function responseTask(response) {
        let stateImages = [];
        let objs = response.data['components']
        objs.filter(a0 => a0.component !== "statePNGButton").forEach(a => {
          a.dimensions.forEach(b => {
            b.componentdimensionstateimages.forEach(c => {
              stateImages.push(c)
            })
          });
        })
        props.setStateImages(stateImages);

  
      }
      apiCall('get', url, {}, responseTask, null, props.setFormError)
    }
  }, [props.updateFetch, props.activeSectionObj])
    


    function handleCanvasClick(e) {
        let classes = e.target.classList;

        // Check if we clicked on the active text layer (which handles its own selection)
        const clickedOnActiveText = e.target.id === `dim_text_${editorOn.current}` ||
                                    e.target.closest(`#dim_text_${editorOn.current}`);

        // If we were in text editing mode and clicked somewhere else, exit edit mode
        if (editorOn.current && !clickedOnActiveText) {
          // Persist tempText to componentDimensions before exiting
          const editingId = editorOn.current;
          const latestText = props.tempTextObj?.current || props.tempText;
          if (latestText && latestText.text !== undefined) {
            const newComponents = [...props.componentDimensions];
            const dimIndex = newComponents.findIndex(d => d.id === editingId);
            if (dimIndex !== -1 && newComponents[dimIndex].html_text) {
              newComponents[dimIndex].html_text = {
                ...newComponents[dimIndex].html_text,
                text: latestText.text,
                charStyleOverrides: latestText.charStyleOverrides || [],
                styleOverrides: latestText.styleOverrides || [],
                css: latestText.css || newComponents[dimIndex].html_text.css
              };
              props.setComponentDimensions(newComponents);
              props.setUnSavedChanges(true);
            }
          }

          window.getSelection()?.removeAllRanges();
          props.setSelection(null);

          // Reset contentEditable on the current text element
          if (textEditDiv.current) {
            textEditDiv.current.contentEditable = false;
            textEditDiv.current.classList.add('readOnly');
          }
          keyboardManager.current.detach();
          editorOn.current = false;
          setIsTextEditing(false);
          setIsSelecting(false);
        }

        if (classes.contains("clearBtn")) {

          clearSelected().then(function(){

            // console.log('handleCanvasClick')

            let curr = reRender;
            console.log('curr',curr+=1)

            //// 2025.06.13: Removed this to correct image shifting for large screens like COG. Not sure if it's used elsewhere.
            // setReRender(curr+=1);

            props.setActiveSettingId(null);
            editorOn.current = false;
            setIsTextEditing(false);
            props.setDropDown(null);

            if (isSelecting) {
              setIsSelecting(false);
            }

          });

        }
    }


    // function delayedUpdateTextOnKeyUp(e) {
    //   clearTimeout(isTypingTimer.current);
    //   if (e) {
    //     isTypingTimer.current = setTimeout(function(){ updateTextOnKeyUp(e) }, 200);
    //   }
    // }

    function handleCopy(e) {
      const selection = window.getSelection();
      const text = selection.toString();

      if (!text) return;

      // Get the container element - use editorOn.current for the actively edited text
      const editingId = editorOn.current || props.activeSettingId;
      const containerElement = document.getElementById('dim_text_' + editingId);

      if (!containerElement) return;

      // Get the active dimension's html_text
      const activeDimension = props.componentDimensions?.find(d => d.id === editingId);
      const currentTextState = getCurrentTextState(props.tempText, activeDimension);

      // Get selection range
      const selRange = getSelectionRange(containerElement);
      if (!selRange) return;

      // Extract text and styles from the selection
      const styleData = extractTextAndStyles(currentTextState, selRange.start, selRange.end);

      // Also set plain text for compatibility with other apps
      e.clipboardData.setData('text/plain', text);
      e.clipboardData.setData('application/json', JSON.stringify(styleData));
      e.preventDefault();

      console.log('handleCopy: extracted', styleData);
    }

    function handlePaste(e) {
      // Parse clipboard data (handles both styled and plain text)
      const pastedData = parseClipboardData(e);

      console.log('handlePaste: pastedData', pastedData);

      if (!pastedData || !pastedData.text) {
        console.log('handlePaste: no pasted data or empty text');
        return;
      }

      // Get the container element - find the canvasText span
      // Use editorOn.current as it tracks the actively edited text layer
      const editingId = editorOn.current || props.activeSettingId;
      const containerElement = document.getElementById('dim_text_' + editingId);

      console.log('handlePaste: containerElement', containerElement, 'editingId', editingId, 'editorOn.current', editorOn.current);

      if (!containerElement) {
        console.log('handlePaste: no container element found');
        return;
      }

      // Get current text state
      const activeDimension = props.componentDimensions?.find(d => d.id === editingId);
      const currentTextState = getCurrentTextState(props.tempText, activeDimension);

      console.log('handlePaste: currentTextState', currentTextState);

      // Get caret position or selection range
      const selRange = getSelectionRange(containerElement);
      const insertPosition = selRange ? selRange.start : getCaretCharacterOffsetWithin(containerElement);
      const deleteCount = selRange ? selRange.length : 0;

      console.log('handlePaste: insertPosition', insertPosition, 'deleteCount', deleteCount);

      // Merge pasted content into current state
      const newState = mergeClipboardContent(currentTextState, pastedData, insertPosition, deleteCount);

      console.log('handlePaste: newState', newState);

      // Update state and immediate ref
      pendingTextState.current = newState;
      if (props.tempTextObj) {
        props.tempTextObj.current = newState;
      }
      props.setTempText(newState);
      props.setUnSavedChanges(true);
      props.setSelection(null);

      // Update componentDimensions directly so pasted text appears immediately
      const newComponents = [...props.componentDimensions];
      const dimIndex = newComponents.findIndex(d => d.id === editingId);
      if (dimIndex !== -1 && newComponents[dimIndex].html_text) {
        newComponents[dimIndex].html_text = {
          ...newComponents[dimIndex].html_text,
          text: newState.text,
          charStyleOverrides: newState.charStyleOverrides,
          styleOverrides: newState.styleOverrides || []
        };
        props.setComponentDimensions(newComponents);
      }

      // Set caret position after paste (after re-render)
      const newCaretPosition = insertPosition + pastedData.text.length;
      setTimeout(() => {
        const textElement = document.getElementById('dim_text_' + editingId);
        if (textElement) {
          textElement.focus();
          setCaretPosition(textElement, newCaretPosition);
        }
      }, 0);

      // Skip keyup events for 500ms - we already updated the state
      // (handles both V keyup and Cmd/Ctrl keyup, plus any delayed events)
      skipKeyUpUntil.current = Date.now() + 500;

      e.preventDefault();

      console.log('handlePaste: complete');
    }

    function handleCutEvent(e) {
      const selection = window.getSelection();
      const text = selection.toString();

      if (!text) return;

      // Get the container element - use editorOn.current for the actively edited text
      const editingId = editorOn.current || props.activeSettingId;
      const containerElement = document.getElementById('dim_text_' + editingId);

      if (!containerElement) return;

      // Get the active dimension's html_text
      const activeDimension = props.componentDimensions?.find(d => d.id === editingId);
      const currentTextState = getCurrentTextState(props.tempText, activeDimension);

      // Get selection range
      const selRange = getSelectionRange(containerElement);
      if (!selRange) return;

      // Extract text and styles from the selection for clipboard
      const styleData = extractTextAndStyles(currentTextState, selRange.start, selRange.end);

      // Set clipboard data
      e.clipboardData.setData('text/plain', text);
      e.clipboardData.setData('application/json', JSON.stringify(styleData));

      // Remove the selected text from state
      const newState = mergeClipboardContent(currentTextState, { text: '' }, selRange.start, selRange.length);

      // Update state and immediate ref
      if (props.tempTextObj) {
        props.tempTextObj.current = newState;
      }
      props.setTempText(newState);
      props.setUnSavedChanges(true);
      props.setSelection(null);

      // Set caret position after cut
      setTimeout(() => {
        const textElement = document.getElementById('dim_text_' + editingId);
        if (textElement) {
          setCaretPosition(textElement, selRange.start);
        }
      }, 0);

      // Skip keyup events for 100ms - we already updated the state
      // (handles both X keyup and Cmd/Ctrl keyup)
      skipKeyUpUntil.current = Date.now() + 100;

      e.preventDefault();

      console.log('handleCut: extracted and removed', styleData);
    }


    // This is the main function for updating the live text input
    function updateTextOnKeyUp(e) {
      // Skip if we just did a paste/cut - the state was already updated
      if (Date.now() < skipKeyUpUntil.current) {
        console.log('updateTextOnKeyUp: skipped (paste/cut just happened)');
        return;
      }

      const selection = window.getSelection();

      if (editorOn.current && selection.type !== "Range") {
        // Guard against null baseNode (happens when all text is deleted)
        if (!selection.baseNode) {
          return;
        }
        const parentElement = selection.baseNode.parentElement;
        const elementStyle = parentElement.style;
        let charIndex = getCaretCharacterOffsetWithin(selection.baseNode.parentElement.parentElement) - 1;

        const activeStyleObj = {};
        // 1. Get Text Content with Line Breaks
        let newText = e.target.textContent;

        console.log('charIndex', charIndex, newText.length)
        
        // 2.Check if the property belongs to the CSSStyleDeclaration instance and ensure that the property is a numeric index (indicating an inline style)
        for (const prop in elementStyle) {
          if (
            Object.hasOwn(elementStyle, prop) &&
            !Number.isNaN(Number.parseInt(prop))
            ){
              if (elementStyle[prop] === 'font-size') {
                let dataFontSize = parentElement.dataset.fontsize;
                let s0 = dataFontSize;
                activeStyleObj[elementStyle[prop]] = parseInt(s0);
              } else if (elementStyle[prop] === 'color') {
                
                let s0 = elementStyle.getPropertyValue(elementStyle[prop]);
                activeStyleObj[elementStyle[prop]] = rgbToHex(s0);
              } else if (elementStyle[prop] === 'touch-action') {
                console.log("pass touch-action: none")
            
              } else {
                activeStyleObj[elementStyle[prop]] = elementStyle.getPropertyValue(elementStyle[prop])
              }

              if (!(elementStyle[prop] === 'letter-spacing')) {
                
                activeStyleObj['letter-spacing'] = 'auto'
            
              } 
             
            }
          }

      

        let newComponents = [ ...props.componentDimensions ];
        let newComponent = newComponents.find(obj => obj.id === props.activeSettingId)
        let newOverides = [];
        let styleOverrides = [];
        let css = {};

        // Guard against newComponent not being found (timing issue during auto-focus)
        if (!newComponent) {
          console.log('updateTextOnKeyUp: newComponent not found for id:', props.activeSettingId);
          return;
        }

        if (newComponent['html_text'] && newComponent['html_text']['css']) {
          css = structuredClone(newComponent['html_text']['css'])
        }

        if (newComponent['html_text'] && (newComponent['html_text']['styleOverrides']|| (props.tempText && props.tempText['styleOverrides']))) {
          if (props.tempText && props.tempText['styleOverrides']) {
            styleOverrides = structuredClone(props.tempText['styleOverrides'])
          } else {
            styleOverrides = structuredClone(newComponent['html_text']['styleOverrides'])
          }
        }

        // Use pending state from previous keyup if available (for rapid typing before debounce fires)
        // Priority: pendingTextState (immediate) > props.tempText (debounced) > saved component
        const immediateState = pendingTextState.current;

        console.log('DEBUG: immediateState=', immediateState, 'props.tempText=', props.tempText, 'charIndex=', charIndex);

        if (immediateState && immediateState['charStyleOverrides']) {
          newOverides = [...immediateState['charStyleOverrides']];
          console.log('DEBUG: using immediateState, newOverides length=', newOverides.length);
        } else if (props.tempText && props.tempText['charStyleOverrides']) {
          newOverides = [...props.tempText['charStyleOverrides']];
          console.log('DEBUG: using props.tempText, newOverides length=', newOverides.length);
        } else if (newComponent['html_text'] && newComponent['html_text']['charStyleOverrides']) {
          newOverides = [...newComponent['html_text']['charStyleOverrides']];
          console.log('DEBUG: using saved component, newOverides length=', newOverides.length);
        }

        // Add or splice newOverrides with charIndex. This is where existing overrides are extended or shortened.

        if (charIndex > -1 && (newOverides && newOverides.length > 0)) {
          if (e.key === "Backspace" || e.key === "Delete") {
            // Current caret position after the key event
            const caretPos = charIndex + 1;

            if (e.key === "Backspace") {
              // Backspace: deleted character was at current caret position
              // (caret moved back by 1 after deletion, so current position = deleted position)
              const deletePos = caretPos;
              if (deletePos >= 0 && deletePos < newOverides.length) {
                newOverides = handleBackspace(newOverides, deletePos + 1);
                console.log('handleBackspace: removed override at index', deletePos, 'result:', newOverides);
              }
            } else {
              // Delete: deleted character was at current caret position (caret didn't move)
              const deletePos = caretPos;
              if (deletePos >= 0 && deletePos < newOverides.length) {
                newOverides = handleDelete(newOverides, deletePos, newOverides.length);
                console.log('handleDelete: removed override at index', deletePos, 'result:', newOverides);
              }
            }

            props.setSelection(null);

            // Final safeguard: ensure overrides length matches text length
            while (newOverides.length > newText.length) {
              // Remove from the caret position if possible, otherwise from end
              const removeIdx = Math.min(caretPos, newOverides.length - 1);
              newOverides.splice(removeIdx, 1);
              console.log('Safeguard: removed extra override at index', removeIdx);
            }

          } else {
            // Calculate how many characters were added
            // Use immediate state for accurate comparison during rapid typing
            let oldTextLength = 0;
            if (immediateState && immediateState['text']) {
              oldTextLength = immediateState['text'].length;
            } else if (props.tempText && props.tempText['text']) {
              oldTextLength = props.tempText['text'].length;
            } else if (newComponent['html_text'] && newComponent['html_text']['text']) {
              oldTextLength = newComponent['html_text']['text'].length;
            }
            const charsAdded = newText.length - oldTextLength;
            console.log('charsAdded:', charsAdded, 'oldLen:', oldTextLength, 'newLen:', newText.length);

            // Only insert overrides if characters were actually added
            if (charsAdded > 0) {
              // Get the style to apply to new characters (inherit from previous char)
              const styleToApply = charIndex > 0 ? (newOverides[charIndex - 1] || 0) : 0;

              // Insert override(s) for the new character(s)
              for (let i = 0; i < charsAdded; i++) {
                newOverides.splice(charIndex, 0, styleToApply);
              }
              console.log('Inserted', charsAdded, 'override(s) with style', styleToApply, 'at index', charIndex);
            }
          }
        }

        // CRITICAL: Ensure charStyleOverrides length always matches text length
        // This catches any edge cases where deletion didn't properly update overrides
        if (newOverides.length !== newText.length) {
          console.log('Length mismatch! overrides:', newOverides.length, 'text:', newText.length, 'charIndex:', charIndex);

          if (newOverides.length > newText.length) {
            // Too many overrides - need to remove some
            // For backspace/delete, remove at caret position
            const removeCount = newOverides.length - newText.length;
            const removeAt = Math.max(0, Math.min(charIndex + 1, newOverides.length - removeCount));
            newOverides.splice(removeAt, removeCount);
            console.log('Removed', removeCount, 'overrides at index', removeAt, 'result:', newOverides);
          } else {
            // Too few overrides - pad with 0
            while (newOverides.length < newText.length) {
              newOverides.push(0);
            }
            console.log('Padded overrides to length', newOverides.length);
          }
        }

        // Use debounced updater to reduce state updates during rapid typing
        if (!debouncedTextUpdater.current) {
          debouncedTextUpdater.current = createDebouncedTextUpdater(props.setTempText, props.setUnSavedChanges);
        }
        const latestTextState = {'text': newText, 'charStyleOverrides': newOverides, 'styleOverrides': styleOverrides, 'css': css};

        // Store immediately in ref for sync access before save (bypasses debounce)
        // Also used for rapid typing to maintain state continuity between keyups
        pendingTextState.current = latestTextState;
        if (props.tempTextObj) {
          props.tempTextObj.current = latestTextState;
        }

        // Update componentDimensions directly ONLY when a selection was just deleted
        // This prevents re-render from restoring old text via dangerouslySetInnerHTML
        // Don't do this on normal typing - it would reset cursor position
        if (props.selection) {
          const editingId = editorOn.current || props.activeSettingId;
          const dimIndex = newComponents.findIndex(d => d.id === editingId);
          if (dimIndex !== -1 && newComponents[dimIndex].html_text) {
            newComponents[dimIndex].html_text = {
              ...newComponents[dimIndex].html_text,
              text: newText,
              charStyleOverrides: newOverides,
              styleOverrides: styleOverrides
            };
            props.setComponentDimensions(newComponents);

            // Restore cursor position after re-render (caret is at charIndex + 1)
            const caretPos = charIndex + 1;
            setTimeout(() => {
              const textElement = document.getElementById('dim_text_' + editingId);
              if (textElement) {
                textElement.focus();
                setCaretPosition(textElement, caretPos);
              }
            }, 0);
          }
        }

        debouncedTextUpdater.current.update(latestTextState);
        console.log('updateEditableText Result', newText, newOverides)
      }


        
          
      }

      function updateTextonKeyDown(e) {
         if (e.key === "Backspace" || e.key === "Delete") {
            const selection = window.getSelection();
            const hasRangeSelection = selection && selection.type === "Range" && selection.toString().length > 0;
            console.log('updateTextonKeyDown', e.key, 'hasRangeSelection:', hasRangeSelection, 'selectedText:', selection?.toString());

            // Don't clear selection state if user is deleting selected text
            // The re-render from setSelection(null) would restore old text via dangerouslySetInnerHTML
            if (!hasRangeSelection) {
              props.setSelection(null);
            }
          }
      }

      function escClear(){
        isDragging.current = false;

        // Persist tempText to componentDimensions before exiting
        const editingId = editorOn.current;
        if (editingId) {
          // Flush any pending debounced text updates first
          if (debouncedTextUpdater.current) {
            debouncedTextUpdater.current.flush();
          }

          const latestText = props.tempTextObj?.current || props.tempText;
          if (latestText && latestText.text !== undefined) {
            const newComponents = [...props.componentDimensions];
            const dimIndex = newComponents.findIndex(d => d.id === editingId);
            if (dimIndex !== -1 && newComponents[dimIndex].html_text) {
              newComponents[dimIndex].html_text = {
                ...newComponents[dimIndex].html_text,
                text: latestText.text,
                charStyleOverrides: latestText.charStyleOverrides || [],
                styleOverrides: latestText.styleOverrides || [],
                css: latestText.css || newComponents[dimIndex].html_text.css
              };
              props.setComponentDimensions(newComponents);
              props.setUnSavedChanges(true);
            }
          }
        }

        // Reset contentEditable on the current text element
        if (textEditDiv.current) {
          textEditDiv.current.contentEditable = false;
          textEditDiv.current.classList.add('readOnly');
        }
        // Detach keyboard listener
        keyboardManager.current.detach();

        // Clear text selection state and native browser selection
        props.setSelection(null);
        window.getSelection()?.removeAllRanges();

        clearSelected().then(function () {

        console.log('escClear')

        props.setActiveSettingId(null);
        editorOn.current = false;
        setIsTextEditing(false);
        props.setDropDown(null);
        selectDrag.current = false;
        // Selection already cleared by clearSelected(), no need to set again
        setIsSelecting(false);
        });
      }
    

      function makeTextEditable(elem){
        if (parseInt(elem.id.replace('dim_text_', '')) !== editorOn.current) {
          textEditDiv.current = elem;
          // Set contentEditable directly - don't rely on React re-render since editorOn is a ref
          elem.contentEditable = true;
          elem.classList.remove('readOnly');
          let sel = window.getSelection();
          let range = new Range();
          range.setStart(elem, elem.childNodes.length);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range)
          elem.focus();
          console.log('makeTextEditable', elem.id, editorOn.current)
        }
        // Use keyboard manager for proper listener cleanup (prevents memory leak)
        keyboardManager.current.attach(escClear);
      }

      // Ref callback for text elements - focuses immediately when the element mounts
      // and it matches the autoFocusTextId
      const textRefCallback = useCallback((elem, dimensionId) => {
        // console.log('textRefCallback called:', dimensionId, 'elem:', !!elem, 'autoFocusTextId:', autoFocusTextId);
        if (elem && dimensionId === autoFocusTextId) {
          // console.log('textRefCallback: auto-focusing', dimensionId);
          // Clear the autoFocus flag first to prevent re-triggering
          setAutoFocusTextId(null);
          // Use requestAnimationFrame to ensure the element is fully rendered
          requestAnimationFrame(() => {
            // Set activeSettingId directly (bypasses showSettings cooldown)
            // This ensures LayerSettings works immediately
            props.setActiveSettingId(dimensionId);
            props.setMultiSelectIds([dimensionId]);
            tempTextObj.current = props.componentDimensions?.find(d => d.id === dimensionId)?.html_text;
            makeTextEditable(elem);
            editorOn.current = dimensionId;
            setIsTextEditing(true);
          });
        }
      }, [autoFocusTextId, props.componentDimensions, props.setActiveSettingId, props.setMultiSelectIds]);   

      function apiToZoom(value0, isLocked, isBackground, valuePercentage) {
        
       
        let result;
        let value = value0;
        // let x_saved = 
        if (valuePercentage && props.activeDisplay.id !== props.defaultDisplay && inset && inset.inset_x === 0) {
          value = parseFloat(valuePercentage.replace('%', ''))
          result = value + "%"
        } else {
          result = value * zoomRatio 
        }
       
        return result
      }


      function zoomToApi(value, isLocked){
        let result;
        result = value/zoomRatio
        
        return parseInt(result)
      }

      function closeText(){
        console.log('closeText')

        // Reset contentEditable on the current text element
        if (textEditDiv.current) {
          textEditDiv.current.contentEditable = false;
          textEditDiv.current.classList.add('readOnly');
        }

        // Detach keyboard listener
        keyboardManager.current.detach();

        editorOn.current = false;
        setIsTextEditing(false);

        clearSelected().then(function () {
          editorOn.current = false;
          setIsTextEditing(false);
          props.setDropDown(null);
          selectDrag.current = false;
          setIsSelecting(false);
        });
      }

      function openText(dimension, retryCount = 0){
        if (dimension.id !== editorOn.current) {
            console.log('openText', dimension.id, 'retry:', retryCount)
            tempTextObj.current = dimension.html_text;
            let htmlElem = document.getElementById("dim_text_" + dimension.id)
            console.log('htmlElem', htmlElem ? 'found' : 'NOT FOUND')

            if (htmlElem) {
              setTimeout(() => {
                makeTextEditable(htmlElem)
                // Set editorOn.current AFTER makeTextEditable so the condition check passes
                editorOn.current = dimension.id;
                setIsTextEditing(true);
              }, 100);
            } else if (retryCount < 5) {
              // Element not ready yet, retry after a short delay
              console.log('openText: element not found, retrying...')
              setTimeout(() => {
                openText(dimension, retryCount + 1);
              }, 200);
            } else {
              console.warn('openText: gave up after 5 retries for dimension', dimension.id)
            }
        }
      }

      useEffect(() => {
        console.log('useEffect triggered - activeSettingId:', props.activeSettingId, 'has componentDimensions:', !!props.componentDimensions, 'pendingFocusId:', pendingFocusId.current);

        // Check for pending focus ID first (dimension wasn't ready before)
        const idToCheck = props.activeSettingId || pendingFocusId.current;

        if (idToCheck && props.componentDimensions) {
          let dimensionIndex = props.componentDimensions.findIndex(obj => obj.id === idToCheck);
          console.log('dimensionIndex:', dimensionIndex, 'looking for id:', idToCheck);

          if (dimensionIndex > -1) {
            // Found the dimension - clear pending
            pendingFocusId.current = null;

            let dimension = props.componentDimensions[dimensionIndex];
            console.log('useEffect dimension check:', dimension.id, 'file_format:', dimension.file_format, 'html_text:', dimension.html_text, 'text value:', dimension.html_text?.text);
            // Auto-open text editor for new (empty) text layers
            // Check for empty string, undefined, or null
            const isEmptyText = dimension.html_text && (dimension.html_text['text'] === '' || !dimension.html_text['text']);
            if (dimension.file_format === 'text' && isEmptyText) {
              console.log('Setting autoFocusTextId to', dimension.id);
              setAutoFocusTextId(dimension.id);
            }
          } else if (props.activeSettingId) {
            // Dimension not found yet - store for later
            console.log('Dimension not found, storing pendingFocusId:', props.activeSettingId);
            pendingFocusId.current = props.activeSettingId;
          }
        }
      }, [props.activeSettingId, props.componentDimensions])

      function svgStrokePadding(dim) {
        if (dim.svg_json && dim.svg_json.objects && dim.svg_json.objects[0].strokeWidth) {
          return dim.svg_json.objects[0].strokeWidth * zoomRatio * 2;
        }
        return 0;
      }

    return(
      <div display={props.activeDisplay.name} className={"canvasContainer clearBtn" + (props.loading === true ? " loading" : "")} onClick={(e) => handleCanvasClick(e)} ref={frameElemBox}>

        {/* Scrollbars */}
        <div className="scrollBar frameScrollBar" ref={scrollBar}>
          <div className="scrollHandle" id="scrollHandle" ref={handle}></div>
        </div>
        <div className="scrollBar frameScrollBarHoriz" ref={scrollBarHoriz}>
          <div className="scrollHandle" ref={handleHoriz}></div>
        </div>

    

        {/* Canvas Area */}
        <div className="canvasPage clearBtn">

 
   

          {/* Canvas Frame */}
          <div ref={frameCanvas} onLoad={() => handleZoomHeight()} id="canvasFormWrap" className={(props.activeSettingId)?("canvasFormWrap inFocus clearBtn"):("canvasFormWrap clearBtn offFocus")}>  


            {/* Canvas Zoom Box */}
            <div className={classNames("canvasZoom","clearBtn")} id="canvasZoom" ref={frameZoomElem} data-zoom={props.zoomNumber} style={{aspectRatio: props.activeDisplay.aspect_ratio}}>


              {/* Guidelines */}
              {inset && frameDelta && zoomRatio && insetZoomRatio && props.activeDisplay && props.zoomNumber && <div className="guidelines" ref={guidelines}>


                <svg className={"guideline"} style={{left: frameDelta[0] + apiToZoom(inset.inset_x, null) + 'px', top: frameDelta[3]}} width={"1px"} height={"1000vh"} ><line x1={0} y1={0} x2={0} y2={"100%"} stroke="#00ffff" strokeWidth="1"/>
                </svg>
                <svg className={"guideline"} style={{left: frameDelta[0] + apiToZoom(inset.inset_width, null) + apiToZoom(inset.inset_x, null) + 'px', top: frameDelta[3]}} width={"1px"} height={"1000vh"} ><line x1={0} y1={0} x2={0} y2={"100%"} stroke="#00ffff" strokeWidth="1"/>
                </svg>
        
                <svg className={"guideline"} style={{left: frameDelta[2], top: frameDelta[1] + apiToZoom(inset.inset_y, null) + 'px' }} width={'1000vw'} height={'1px'} ><line x1={0} y1={0} x2={"100%"} y2={0} stroke="#00ffff" strokeWidth="1"/>
                </svg>

                <svg className={"guideline"} style={{left: frameDelta[2], top: frameDelta[1] + apiToZoom(inset.inset_height, null) + apiToZoom(inset.inset_y, null) + 'px' }} width={'1000vw'} height={'1px'} ><line x1={0} y1={0} x2={"100%"} y2={0} stroke="#00ffff" strokeWidth="1"/>
                  </svg>

                        
                {props.activeDisplay.subdisplays.map( obj => (<svg key={'line_' + obj.id} className={"guideline"} style={{left: frameDelta[0] + apiToZoom(obj.x_pos) + 'px', top: frameDelta[3] + apiToZoom(obj.y_pos) + 'px' }} width={'1px'} height={'1000vw'} ><line x1={0} y1={0} x2={0} y2={"100%"} stroke="#00ffff" strokeWidth="1"/>
                </svg>))}


              </div>}

             
              

              {/* Canvas Box for Active Display Handling */}
              <div className={classNames(
                  "canvasForm",
                  props.showFullCanvas && "showFull",
                  props.isDrawing && "isDrawing"
                )} id={"canvasForm"} ref={frameElem} style={{aspectRatio: props.activeDisplay.aspect_ratio}} >

                {/* Clip Path to Hide Layers Outside of Active Display Box */}
                <div className="clipPath" style={{"position": "relative"}} id="canvasPath">


                {props.isDrawing && <span className="sketchCanvas">
                  <span className="sketchCover"></span>
                  <PaperCanvas 
                    tool={props.isDrawing} 
                    user={props.user} 
                    width={apiToZoom(props.activeDisplay.width_px)} 
                    height={apiToZoom(props.activeDisplay.height_px)} 
                    handleLayerAdded={props.handleLayerAdded}
                    zoomRatio={zoomRatio}
                    svgPath={null}
                    editing={true}
                    id={props.activeSectionObj.id}
                    activeDisplay={props.activeDisplay}
                    objId={null}
                    updateFetch={props.updateFetch}
                    setUpdateFetch={props.setUpdateFetch}
                    fetchJSON={props.fetchJSON}
                    unSavedChanges={props.unSavedChanges}
                    reRender={reRender}
                    setReloadFrame={props.setReloadFrame}
                    reloadFrame={props.reloadFrame}
                    componentDimensions={props.componentDimensions}
                    setComponentDimensions={props.setComponentDimensions}
                    escClear={escClear}
                    showSettings={props.showSettings}
                    setNewComponentDimension={props.setNewComponentDimension}
                    setActiveSectionObj={props.setActiveSectionObj}
                    setIsDrawing={props.setIsDrawing}
                    setFormError={props.setFormError}
                    setShowLoader={props.setShowLoader}
                    />
                </span>}

                {(props.activeSettingId && props.activeSectionObj && props.componentDimensions.find(a => a.id === props.activeSettingId) && props.componentDimensions.find(a => a.id === props.activeSettingId).file_format === 'svg' && props.componentDimensions.find(a => a.id === props.activeSettingId).svg_json) && <span
                  // style={{transform: 'rotate(' + props.componentDimensions.find(a => a.id === props.activeSettingId).rotation + 'deg)'}}
                  className="sketchCanvas" data-id={props.activeSettingId}>
                <span className="sketchCover" onClick={() => escClear()}></span>
                  <PaperCanvas 
                    tool={props.isDrawing} 
                    user={props.user} 
                    width={apiToZoom(props.activeDisplay.width_px)} 
                    height={apiToZoom(props.activeDisplay.height_px)} 
                    objWidth={apiToZoom(props.componentDimensions.find(a => a.id === props.activeSettingId).width) - svgStrokePadding(props.componentDimensions.find(a => a.id === props.activeSettingId))}
                    objHeight={apiToZoom(props.componentDimensions.find(a => a.id === props.activeSettingId).height) - svgStrokePadding(props.componentDimensions.find(a => a.id === props.activeSettingId))}
                    handleLayerAdded={props.handleLayerAdded}
                    zoomRatio={zoomRatio}
                    svgString={props.componentDimensions.find(a => a.id === props.activeSettingId).svg_string}
                    svgJSON={props.componentDimensions.find(a => a.id === props.activeSettingId).svg_json}
                    x_pos={apiToZoom(props.componentDimensions.find(a => a.id === props.activeSettingId).x_pos)}
                    y_pos={apiToZoom(props.componentDimensions.find(a => a.id === props.activeSettingId).y_pos)}
                    editing={true}
                    id={props.activeSectionObj.id}
                    activeDisplay={props.activeDisplay}
                    objId={props.activeSettingId}
                    fetchJSON={props.fetchJSON}
                    unSavedChanges={props.unSavedChanges}
                    reRender={reRender}
                    setReRender={setReRender}
                    setUnSavedChanges={props.setUnSavedChanges}
                    componentDimensions={props.componentDimensions}
                    setComponentDimensions={props.setComponentDimensions}
                    reloadFrame={props.reloadFrame}
                    rotation={props.componentDimensions.find(a => a.id === props.activeSettingId).rotation}
                    layerOpacity={props.componentDimensions.find(a => a.id === props.activeSettingId).opacity}
                    escClear={escClear}
                    showSettings={props.showSettings}
                    setNewComponentDimension={props.setNewComponentDimension}
                    />

                </span>}
    
                  
                  {/* Inset Bounds */}
                  {inset && <span className="bounds" id="bounds" style={{left: apiToZoom(inset.inset_x,null), top: apiToZoom(inset.inset_y,null), width: apiToZoom(inset.inset_width,null) + "px", height: apiToZoom(inset.inset_height,null) + "px", position: 'absolute'}}></span>}

                  {/* Layers */}
                  {zoomRatio && props.componentDimensions && props.componentDimensions
                    .sort((a, b) => {
                      // webview layers always render last (on top), matching the native BrowserView in the presentation
                      const aWeb = a.file_format === 'webview' ? 1 : 0;
                      const bWeb = b.file_format === 'webview' ? 1 : 0;
                      if (aWeb !== bWeb) return aWeb - bWeb;
                      return a.component_ordering - b.component_ordering;
                    })
                    // .filter(file => (file.active === true))
                    .map((dimension, i) => 
                  (dimension) &&
                    (<Rnd
                      scale={props.zoomNumber}
                      key={'draggable_' + dimension.id + "_" + props.activeDisplay.id + "_" + reRender}
                      onClick={(e) => {
                          if (dimension.background||dimension.change_lock||(dimension.file_format === 'svg' && dimension.svg_json)) {

                              // if (layerClickCooldownRef.current) {
                              //   return;
                              // }
                              // // Engage 1s cooldown
                              // layerClickCooldownRef.current = true;
                              // setTimeout(() => {
                              //   layerClickCooldownRef.current = false;
                              // }, 1000);

                            // console.log('e', e)
                            props.showSettings(dimension.id, false, e)
                          }
                      }}
                      onDoubleClick={(e) => {
                        if ((dimension.file_format === "text")&&(dimension.html_text)) {
                          openText(dimension)
                        }
                      }}
                      id={"canvasForm1_draggable_" + dimension.id}
                      className={classNames(
                        !dimension.active && "off"
                      )}
                      position={{
                        x: apiToZoom(dimension.x_pos, dimension.is_locked) - (dimension.svg_json && dimension.svg_json.objects && dimension.svg_json.objects[0].strokeWidth ? dimension.svg_json.objects[0].strokeWidth / 2 : 0),
                        y: apiToZoom(dimension.y_pos, dimension.is_locked) - (dimension.svg_json && dimension.svg_json.objects && dimension.svg_json.objects[0].strokeWidth ? dimension.svg_json.objects[0].strokeWidth / 2 : 0)
                      }}

                      size={{
                        width: dimension.background ? "100%":apiToZoom(dimension.width + (dimension.svg_json && dimension.svg_json.objects && dimension.svg_json.objects[0].strokeWidth * props.zoomRatio * 2), dimension.is_locked, dimension.background, dimension.width_perc),
                        height: dimension.background ? "100%": apiToZoom(dimension.height + (dimension.svg_json && dimension.svg_json.objects && dimension.svg_json.objects[0].strokeWidth * props.zoomRatio * 2), dimension.is_locked, dimension.background, dimension.height_perc)
                      }}
                      // bounds={inset?".bounds":"parent"}
                      // dragGrid={[4,4]}
                      lockAspectRatio={(dimension.file_format === "text")?false:((props.lockAr)?true:false)}
                      enableResizing={(dimension.background || (dimension.file_format === 'svg' && dimension.svg_json) || dimension.file_format === 'popup')?(false):(true)}
                      disableDragging={( (dimension.file_format === 'svg' && dimension.svg_json) || dimension.background||isTextEditing||dimension.change_lock||(props.activeDisplay.id !== props.defaultDisplay && dimension.is_locked))?(true):(false)}
                      onDragStart={(e) => {
                        //   if (layerClickCooldownRef.current) {
                        //   return;
                        // }
                        // // Engage 1s cooldown
                        // layerClickCooldownRef.current = true;
                        // setTimeout(() => {
                        //   layerClickCooldownRef.current = false;
                        // }, 1000);

                        props.showSettings(dimension.id, false, e)
            
                      }}
                      onDrag={(e, d) => {
                        isDragging.current = true;
                      }}
                      onDragStop = {(e, d) => { 
                        var newComponents = [ ...props.componentDimensions ];
                        var newObj = newComponents.find(obj => (obj.id === dimension.id));
                        if ((newObj['x_pos'] !== zoomToApi(d.x, dimension.is_locked))&&(newObj['y_pos']!==zoomToApi(d.y, dimension.is_locked))) {
                          let x = d.x;
                          let y = d.y;
                          if (inset) {
                            if (x < apiToZoom(inset.inset_x, null) && x <= apiToZoom(inset.inset_width, null)) {
                              x = apiToZoom(inset.inset_x,null)
                            } else if (x > apiToZoom(inset.inset_width-dimension.width+inset.inset_x, null)) {
                              x = apiToZoom(inset.inset_width - dimension.width+inset.inset_x,null)
                            } else {
                              // pass
                            }

                            if (y < apiToZoom(inset.inset_y, null) && y <= apiToZoom(inset.inset_height, null)) {
                              y = apiToZoom(inset.inset_y,null)
                            } else if (y > apiToZoom(inset.inset_height-dimension.height+inset.inset_y, null)) {
                              y = apiToZoom(inset.inset_height - dimension.height+inset.inset_y,null)
                            } else {
                              // pass
                            }
                            
                          }
                          newObj['x_pos'] = zoomToApi(x, dimension.is_locked);
                          newObj['y_pos'] = zoomToApi(y, dimension.is_locked);
                          setTimeout(() => {
                            if (newObj) {
                              try {
                                document.getElementById('x_pos_dim_' + dimension.id).value = newObj['x_pos'];
                                document.getElementById('y_pos_dim_' + dimension.id).value = newObj['y_pos']; 
                              } catch (error) {
                                console.error('obj not found', 'x_pos_dim_' + dimension.id, 'y_pos_dim_' + dimension.id)
                              }
                              
                            }
                          }, 100);
                          props.setComponentDimensions(newComponents);
                          props.setUnSavedChanges(true);
                        }
                      
                        setTimeout(() => {
                          isDragging.current = false;
                        }, 300);
                      }}
                      onResizeStop={(e, direction, ref, delta, position) => {

                        var newComponents = [ ...props.componentDimensions ];
                        var newObj = newComponents.find(obj => (obj.id === dimension.id));
                        if (newObj) {
                          newObj['width'] = zoomToApi(ref.offsetWidth, dimension.is_locked);
                          newObj['height'] = zoomToApi(ref.offsetHeight, dimension.is_locked);
                          newObj['x_pos'] = zoomToApi(position.x, dimension.is_locked);
                          newObj['y_pos'] = zoomToApi(position.y, dimension.is_locked);
                          
                          setTimeout(() => {
                            if (newObj) {
                              if (document.getElementById('x_pos_dim_' + dimension.id)){
                                document.getElementById('x_pos_dim_' + dimension.id).value = newObj['x_pos']
                              }
                              if (document.getElementById('y_pos_dim_' + dimension.id)) {
                                document.getElementById('y_pos_dim_' + dimension.id).value = newObj['y_pos'];
                              }
                              if (document.getElementById('width_dim_' + dimension.id)){
                                document.getElementById('width_dim_' + dimension.id).value = newObj['width'];
                              }
                              if (document.getElementById('height_dim_' + dimension.id)){
                                document.getElementById('height_dim_' + dimension.id).value = newObj['height'];
                              }
                              
                              
                            }
                          }, 100);
                          props.setComponentDimensions(newComponents);
                          props.setUnSavedChanges(true);
                        }
                        
                      }}
                      >
                      <div
                      style={{transform: 'rotate(' + dimension.rotation + 'deg)', transformOrigin: "top left"}}
                      className={
                        "mediaThumb draggable" +
                        (((props.activeSettingId === dimension.id) && (dimension.file_format !== 'svg' || !dimension.svg_json)) ?" focus":"") +
                        ((props.multiSelectIds.includes(dimension.id) && (props.multiSelectIds.length > 1)) ?
                        " focus multi":"") + (((dimension.html_text && editorOn.current && dimension.file_format === "text" && props.activeSettingId === dimension.id)?" text"
                        :"")) +
                        (dimension.background ? " bkgLayer":"") +
                        (dimension.file_format === 'webview' ? ' webviewLayer' : '')

                        }
                        id={"card_" + dimension.id}>
                        <div 
                          className={"canvas-card" + ((editorOn.current === dimension.id )?" open":"")}
                          id={"cardInner_" + dimension.id}
                          data-ordering={dimension.component_ordering}
                          >
                      
                          <span className="resizer topLeft"></span>
                              <span className="resizer topRight"></span>
                              <span className="resizer bottomRight"></span>
                              <span className="resizer bottomLeft"></span>
                            <div className="canvas-card-inner">
                              
                              <div 
                              className="draggableImage canvas-card-front editorLayer"
                              
                              >

                            
                  
                                    { props.stateImages.filter(cdsi => parseInt(cdsi.state_id) === props.activeStateId && cdsi.componentdimension === dimension.id && cdsi.image).map((obj, i) => (
                                        <img
                                        key={'stateImg'+i}
                                        draggable="false"
                                        className={"imgDefault"}
                                        src={obj.image_path}
                                        alt=""
                                      />
                                      ))

                                    }

                                    { props.stateImages.filter(cdsi => (parseInt(cdsi.state_id) === props.activeStateId) && (cdsi.componentdimension === dimension.id) && cdsi.video).map((obj, i) => (
                                        <video 
                                        key={'stateImg'+i}
                                        draggable="false" 
                                        className="vidDefault"
                                        width={apiToZoom(dimension.width, dimension.is_locked)}
                                        height={apiToZoom(dimension.height, dimension.is_locked)}
                                        playsInline
                                        >
                                    
                                          <source src={obj.video_path} type="video/mp4" />
                                        </video>
                                      
                                      ))

                                    }
                                    
                                
                                  {(
                                  ((dimension.file_format === 'img')
                                    && (props.stateImages.filter(cdsi => parseInt(cdsi.state_id) === props.activeStateId).length < 1 && dimension.background === false))
                                  ||(dimension.file_format === 'statePNGButton')) && (
                                    <img
                                      draggable="false"
                                      className={"imgDefault" + ((props.activeStateId === dimension.component_id)?" on":"")}
                                      src={(props.activeStateId === dimension.component_id)?(dimension.image_on_opt_path?dimension.image_on_opt_path:dimension.image_opt_path):(dimension.image_opt_path)}
                                      style={{opacity: dimension.opacity/100}}
                                      alt=""
                                    />
                                  )}

                                  {dimension.background_color && dimension.file_format === 'img' && dimension.image_opt_path === "" && <span className="backgroundColor" style={{backgroundColor: dimension.background_color, width: '100%', height: '100%'}} />}

                                  {(
                                    ((dimension.file_format === 'img' && dimension.image_opt_path !== "" && dimension.background === true))) && (
                                      <img
                                        draggable="false"
                                        className={"imgDefault"}
                                        src={(props.activeStateId === dimension.component_id)?(dimension.image_on_opt_path?dimension.image_on_opt_path:dimension.image_opt_path):(dimension.image_opt_path)}
                                        style={{opacity: dimension.opacity/100}}
                                        alt=""
                                      />
                                    )}
                                  
                                    {(
                                    ((dimension.file_format === 'popup'))) && (
                                      <img
                                        draggable="false"
                                        className={"imgDefault"}
                                        src={dimension.svg_path}
                                        style={{opacity: dimension.opacity/100}}
                                        alt=""
                                      />
                                    )}
                          


                                  {((dimension.id !== props.activeSettingId) && (dimension.file_format === 'svg') && dimension.svg_json) && (
                                    <span
                                    className={classNames("paperBox")}
                                    style={{opacity: dimension.opacity/100}}
                                    >
                                    <PaperCanvas
                                    key={'svg_' + dimension.id + '_' + dimension.width + '_' + dimension.height + '_' + reRender}
                                    user={props.user}
                                    width={apiToZoom(dimension.width)}
                                    height={apiToZoom(dimension.height)}
                                    objWidth={apiToZoom(dimension.width) - svgStrokePadding(dimension)}
                                    objHeight={apiToZoom(dimension.height) - svgStrokePadding(dimension)}
                                    handleLayerAdded={props.handleLayerAdded}
                                    zoomRatio={zoomRatio}
                                    svgString={dimension.svg_string}
                                    svgJSON={dimension.svg_json}
                                    x_pos={dimension.x_pos}
                                    y_pos={dimension.y_pos}
                                    editing={false}
                                    objId={dimension.id}
                                    escClear={escClear}
                                    rotation={dimension.rotation}
                                    />
                                    </span>
                                    )}

                                  {(dimension.file_format === 'svg' && !dimension.svg_json && (dimension.image_opt_path || dimension.svg_path)) && (
                                    <img
                                      draggable="false"
                                      className={"imgDefault"}
                                      src={dimension.image_opt_path || dimension.svg_path}
                                      style={{opacity: dimension.opacity/100}}
                                      alt=""
                                    />
                                  )}

                                  {(dimension.file_format === 'vid') && (
                                    <video
                                    key={dimension.video_path}
                                    draggable="false"
                                    className="vidDefault"
                                    width={apiToZoom(dimension.width, dimension.is_locked)}
                                    height={apiToZoom(dimension.height, dimension.is_locked)}
                                    playsInline
                                    style={{opacity: dimension.opacity/100}}
                                    >
                                      <source src={dimension.video_path} type="video/mp4" />
                                    </video>
                                    )}
                                  
                                    {((dimension.file_format === "text")&&(dimension.html_text)) &&
                                    <span
                                      name="textValue"
                                      className={"canvasText" + ((editorOn.current === dimension.id )?"":" readOnly")}
                                      contentEditable={(editorOn.current === dimension.id)?true:false}
                                      suppressContentEditableWarning={true}
                                      ref={(elem) => textRefCallback(elem, dimension.id)}
                                      onMouseDown={() => {
                                        // Clear any existing selection on mousedown (before potential drag-select)
                                        if (props.selection) {
                                          window.getSelection()?.removeAllRanges();
                                          props.setSelection(null);
                                        }
                                      }}
                                      onKeyUp={(e) => updateTextOnKeyUp(e)}
                                      onKeyDown={(e) => updateTextonKeyDown(e)}
                                      onSelect={() => {(editorOn.current === dimension.id ) && onSelectStart(
                                        dimension.html_text,
                                        dimension.id,
                                        props.tempText
                                      )}}
                                      onCopy={(e) => handleCopy(e)}
                                      onPaste={(e) => handlePaste(e)}
                                      onCut={(e) => handleCutEvent(e)}
                                      // onDoubleClick={(e) => makeTextEditable(e)}
                                      id={"dim_text_" + dimension.id}
                                      data-fontsize={dimension.html_text.css['font-size']}
                                      style={processCSS(dimension.html_text.css, (insetZoomRatio ? insetZoomRatio : props.zoomRatio), dimension.opacity)}
                                      dangerouslySetInnerHTML={{__html:
                                        processHtmlText(
                                          dimension.html_text,
                                          props.zoomRatio,
                                          "dim_text_" + dimension.id,
                                          // Only pass tempText when there's an active selection (for highlighting)
                                          // Don't pass during typing to avoid caret reset
                                          (props.selection && props.selection.dimensionId === dimension.id)
                                            ? (pendingTextState.current || props.tempText)
                                            : null,
                                          (props.selection && props.selection.dimensionId === dimension.id)
                                            ? {start: props.selection.selectionRange[0], end: props.selection.selectionRange[1]}
                                            : null
                                        )}}>
                                    
                                      </span>
                                      
                                    }

                                    {(dimension.file_format === 'webview') && (
                                      <div style={{width: '100%', height: '100%', opacity: dimension.opacity/100, borderRadius: dimension.webview_frameless ? '0' : '8px 8px 0 0', filter: 'drop-shadow(0 12px 24px rgba(0,0,0,0.25))'}}>
                                      <div style={{width: '100%', height: '100%', background: '#aaa', display: 'flex', flexDirection: 'column', overflow: 'hidden', borderRadius: dimension.webview_frameless ? '0' : '8px 8px 0 0'}}>
                                        {!dimension.webview_frameless && <div style={{height: '34px', minHeight: '34px', background: '#c8c8c8', display: 'flex', alignItems: 'center', padding: '0 8px', gap: '5px', flexShrink: 0}}>
                                          {/* back */}
                                          <svg width="14" height="14" viewBox="0 0 24 24" fill="#888"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
                                          {/* forward */}
                                          <svg width="14" height="14" viewBox="0 0 24 24" fill="#888"><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>
                                          {/* reload */}
                                          <svg width="14" height="14" viewBox="0 0 24 24" fill="#888"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>
                                          <div style={{flex: 1, background: '#c8c8c8', borderRadius: '4px', height: '18px', display: 'flex', alignItems: 'center', padding: '0 6px', overflow: 'visible'}}>
                                            <span style={{fontSize: '9px', color: '#555', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: 1.4}}>
                                              {dimension.webview_url || 'www.website.com'}
                                            </span>
                                          </div>
                                          {/* fullscreen */}
                                          <svg width="14" height="14" viewBox="0 0 24 24" fill="#888" style={{flexShrink: 0}}><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg>
                                        </div>}
                                        <div style={{flex: 1, background: '#fff', display: 'flex', flexDirection: 'column', overflow: 'hidden'}}>
                                          {/* simulated page header */}
                                          <div style={{height: '10%', minHeight: '28px', background: '#f0f0f0', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', padding: '0 16px', gap: '12px', flexShrink: 0}}>
                                            <div style={{width: '60px', height: '8px', background: '#d0d0d0', borderRadius: '3px'}} />
                                            <div style={{flex: 1}} />
                                            <div style={{width: '40px', height: '8px', background: '#d0d0d0', borderRadius: '3px'}} />
                                            <div style={{width: '40px', height: '8px', background: '#d0d0d0', borderRadius: '3px'}} />
                                            <div style={{width: '40px', height: '8px', background: '#d0d0d0', borderRadius: '3px'}} />
                                          </div>
                                          {/* simulated page body */}
                                          <div style={{flex: 1, padding: '20px 16px', display: 'flex', flexDirection: 'column', gap: '10px'}}>
                                            <div style={{width: '55%', height: '14px', background: '#e8e8e8', borderRadius: '3px'}} />
                                            <div style={{width: '80%', height: '8px', background: '#efefef', borderRadius: '3px'}} />
                                            <div style={{width: '70%', height: '8px', background: '#efefef', borderRadius: '3px'}} />
                                            <div style={{width: '75%', height: '8px', background: '#efefef', borderRadius: '3px'}} />
                                            <div style={{height: '12px'}} />
                                            <div style={{width: '100%', height: '22%', minHeight: '40px', background: '#f5f5f5', borderRadius: '4px', border: '1px solid #e8e8e8'}} />
                                            <div style={{height: '8px'}} />
                                            <div style={{width: '60%', height: '8px', background: '#efefef', borderRadius: '3px'}} />
                                            <div style={{width: '75%', height: '8px', background: '#efefef', borderRadius: '3px'}} />
                                          </div>
                                        </div>
                                      </div>
                                      </div>
                                    )}

                              </div>

                            </div>
                          </div>
                      </div>
                    </Rnd>)
                  
                  )}
    
                  {!props.activeSectionObj && props.narrative && <img src={Config.mediaURL + props.narrative.screenshot} className="screenshot" alt="" />}
                
                </div>
                    
              </div>
            
            </div>
          
          </div>
          
                    
        </div>
      </div>
    )
}

export default Frame;

//     <PaperCanvas />
// <SvgFreehand />